import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38a88a79"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "cmc-dialog-destination",
  class: "dialog-portal"
}, null, -1))

import { store, storeModuleTypes, environmentGetterTypes, vueExports } from 'vue-infra';
import { appName } from '../config';
import './styles/app.scss';


import { appCode } from '../config';

const __default__ = {
  name: appCode,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { computed } = vueExports;
const theme = computed(() => {
  return store.getters[`${storeModuleTypes.ENVIRONMENT}/${environmentGetterTypes.CURRENT_ACTIVE_THEME}`];
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: _unref(appName),
    class: _normalizeClass([_unref(appCode), _unref(appName), _unref(theme)])
  }, [
    (_openBlock(), _createBlock(_component_router_view, {
      name: _unref(appCode),
      key: _ctx.$route.fullPath
    }, null, 8, ["name"])),
    _hoisted_2
  ], 10, _hoisted_1))
}
}

})